import * as actions from 'app/actions/onboarding';
import * as client from './contentful-client';

export const fetchSelectPage = () => ({
  promise: () => client.getPage('onboarding-select'),
  events: ['PROMISE_PENDING', actions.SET_SELECT_PAGE, 'PROMISE_ERROR'],
});

export const fetchInstructionsPage = () => ({
  promise: () => client.getPage('onboarding-instructions'),
  events: ['PROMISE_PENDING', actions.SET_INSTRUCTIONS_PAGE, 'PROMISE_ERROR'],
});

export const fetchUnboxingPage = () => ({
  promise: () => client.getPage('onboarding-unboxing'),
  events: ['PROMISE_PENDING', actions.SET_UNBOXING_PAGE, 'PROMISE_ERROR'],
});

export const fetchGlowforgeNamePage = () => ({
  promise: () => client.getPage('onboarding-machine-naming'),
  events: ['PROMISE_PENDING', actions.SET_GLOWFORGE_NAME_PAGE, 'PROMISE_ERROR'],
});

export const fetchOnboardingFinishPage = () => ({
  promise: () => client.getPage('onboarding-finish-page'),
  events: ['PROMISE_PENDING', actions.SET_ONBOARDING_FINISH_PAGE, 'PROMISE_ERROR'],
});

export const nameMachine = (serial, name) => ({
  promise: async http => http.post(
    `/gfcore/users/machines/${serial}/set_name`,
    { name },
  ),
  events: ['PROMISE_PENDING', actions.SET_GLOWFORGE_NAMED, 'PROMISE_ERROR'],
});



// WEBPACK FOOTER //
// ./app/api/onboarding-api.js